import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReservationDataRepository from '../../../../data/repositories/ReservationDataRepository';
import ReservationRepository from '../../../repositories/ReservationRepository';
import DateHelpers from '@/core/helpers/DateHelper';
import { dateNumberToString } from '../../../../presentation/reusables/Date/helpers';

export const arrayResources: any = {
  T: 'Reserva de tablet',
  C: 'Reserva de computadora'
};

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_SUBSCRIBEDS_TABLETS_REQUEST });
    const repository: ReservationRepository = new ReservationDataRepository();
    const response = yield call(repository.getSubscribedsTablets);
    if (!response) {
      yield put({
        type: Types.GET_SUBSCRIBEDS_TABLETS_FAILURE,
        error: 'No se pudo leer los datos.'
      });
      return;
    }

    const subscribedsTablets = response.subscribeds?.filter(
      (e: any) => e.type === 'T' || e.type === 'C'
    );
    const subscribeds = subscribedsTablets.map((e: any) => {
      const resourceName = arrayResources[e.type];
      const formatedDate = dateNumberToString(e.date, 'medium');
      const minutesDiff = DateHelpers.getMinutesSubstractFromCurrentTime(
        e.date,
        e.hourStart
      );
      const disabled = minutesDiff < 0 ? Math.abs(minutesDiff) > 10 : false;
      return {
        ...e,
        formatedDate,
        disabled,
        resourceName
      };
    });
    yield put({
      type: 'SUBSCRIBE_RESOURCE_CLEAR'
    });
    yield put({
      type: 'GET_TABLET_DETAIL_CLEAR'
    });
    // yield put({
    //   type: 'GET_RESERVATION_DETAIL_CLEAR'
    // });
    yield put({
      type: Types.GET_SUBSCRIBEDS_TABLETS_SUCCESS,
      data: { subscribeds }
    });
  } catch (error) {
    yield put({
      type: Types.GET_SUBSCRIBEDS_TABLETS_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
